<template>
  <div class="footerbox">
    <!--  底部  -->
    <div class="bottom-box">
      <div class="banner">
        <img
          src="@/assets/other/black.png"
          style="width: 100%; height: 350px"
          alt=""
        />

        <div class="table-container">
          <!-- 内容表格部分 -->
          <div class="content-table">
            <!-- 表头 -->
            <div class="table-row header">
              <div class="table-cell">服务</div>
              <div class="table-cell">典型案例</div>
              <div class="table-cell">关于我们</div>
              <div class="table-cell">联系方式</div>
            </div>

            <!-- 表格内容 -->
            <div class="table-row">
              <div class="table-cell">
                <div class="footer-group-item" @click="goToWorkTab('device')">设备服务</div>
                <div class="footer-group-item" @click="goToWorkTab('engineer')">工程师服务</div>
                <div class="footer-group-item" @click="goToWorkTab('operation')">运维服务</div>
              </div>
              <div class="table-cell">
                <div class="footer-group-item" @click="goToCooperation('blueMoon')">蓝月亮安全</div>
                <div class="footer-group-item" @click="goToCooperation('regulatory')">银保监安全</div>
              </div>
              <div class="table-cell">
                <div class="footer-group-item" @click="goToWorkspace('#intro')">公司介绍</div>
                <div class="footer-group-item" @click="goToWorkspace('#history')">发展历程</div>
                <div class="footer-group-item" @click="goToWorkspace('#partners')">合作伙伴</div>
                <div class="footer-group-item" @click="goToWorkspace('#certificates')">公司资质</div>
                <div class="footer-group-item" @click="goToWorkspace('#news')">公司动态</div>
              </div>

              <div class="table-cell">
              <div class="footer-group-item" style="cursor: text;font-weight: 200;">+86 186 8843 1450</div>
              <div class="footer-group-item" style="cursor: text;font-weight: 200;">+86 186 8053 1298</div>
              </div>

            </div>
          </div>
        </div>
        <div class="beian">
          <div class="heibox"></div>
          <div class="xian"><img src="@/assets/other/Shape.png" /></div>
          <span style="font-weight: 100; font-size: 16px">
            Copyright © 2025
            鹏海信息&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;粤ICP备17017451号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持：嘉睿信息</span
          >
          <!-- <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;">湘ICP备2022022042号-1</a> -->
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goSign() {
      this.$router.push({
        path: "/Signup",
      });
    },
    goToWorkTab(tab) {
      // 使用name跳转并传递params
      this.$router.push({
        name: "wordList",
        // name:'cooperation',
        params: {
          tab: tab,
        },
      });
    },
    goToCooperation(tab) {
      // 跳转到合作案例页面并传递tab参数
      this.$router.push({
        name: "cooperation",
        params: {
          tab: tab,
        },
      });
    },
    goToWorkspace(anchor) {
      if (this.$route.path === "/workspace") {
        // 如果已经在workspace页面，直接滚动到锚点
        const element = document.querySelector(anchor);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
          });
        }
        // 更新URL hash
        history.pushState(null, null, anchor);
      } else {
        // 如果不在workspace页面，正常跳转
        this.$router.push({
          path: "/workspace",
          hash: anchor,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// .zitis {
//   white-space: normal;
// }

.table-cell:hover {
  // text-decoration: underline;
  cursor: pointer;
}

.footerbox {
  width: 100%;
  margin-top: -30px;

  .bottom-box {
    width: 100%;
    position: relative;

    .banner {
      position: relative;
      width: 100%;

      .bg-image {
        width: 100%;
        height: 400px;
        object-fit: cover;
        display: block;
      }

      .table-container {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        max-width: 1080px;
        padding: 0 7px;
        box-sizing: border-box;

        .content-table {
          width: 100%;

          .table-row {
            display: flex;
            padding: 4px 0;

            &.header {
              // border-bottom: 1px solid rgba(255,255,255,0.3);
              .table-cell {
                font-weight: 350;
                font-size: 20px;
                letter-spacing: 2px;
              }
            }

            .table-cell {
              flex: 1;
              text-align: left;
              color: #ffffff;
              padding: 0 20px;
              box-sizing: border-box;
              white-space: nowrap;
              min-width: 100px;

              &:nth-child(1) {
                width: 18%;
              }

              &:nth-child(2) {
                width: 34%;
              }

              &:nth-child(3) {
                width: 18%;
              }

              &:nth-child(4) {
                width: 34%;
              }

              &.underline-cell {
                text-decoration: underline;
                font-family: "Source Han Sans";
              }

              &.ziti {
                font-weight: 300;
                font-size: 16px;
                // white-space:normal;
              }
            }
          }
        }
      }

      .beian {
        position: absolute;
        bottom: 10px;

        left: 0;
        width: 100%;
        text-align: center;

        .xian {
          width: 100%;
          max-width: 1400px;
          margin: auto;
          opacity: 0.5;
          padding: 10px 10px;

          img {
            width: 100%;
            height: auto;
          }
        }

        .heibox {
          height: 50px;
        }

        span {
          color: white;
          font-size: 16px;
          white-space: nowrap;
          margin-bottom: 80px;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .table-container {
    padding: 0 15px !important;
  }

  .table-cell {
    font-size: 16px !important;
    padding: 0 10px !important;
  }
}

@media (max-width: 768px) {
  .table-row {
    padding: 8px 0 !important;
  }

  .table-cell {
    font-size: 14px !important;
    padding: 0 8px !important;

    &:nth-child(1) {
      width: 20% !important;
    }

    &:nth-child(2) {
      width: 30% !important;
    }

    &:nth-child(3) {
      width: 20% !important;
    }

    &:nth-child(4) {
      width: 30% !important;
    }
  }

  .beian span {
    font-size: 14px !important;
  }
}

.footer-group-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  letter-spacing: 1px;
  color: #fff;
}
.footer-group-item {
  margin-bottom: 6px;
  font-weight: 300;
  cursor: pointer;
  transition: color 0.2s;
  color: #fff;
  font-size: 16px;
  margin: auto;
  margin-top: 8px;
}
.footer-group-item:hover {
  color: #4e8cff;
}
.table-cell.ziti {
  font-weight: 100;
  font-size: 16px;
  white-space: normal;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue